export const PIN = 'PIN';
export const SCREENLOCKED = 'SCREENLOCKED';
export const BATCH_NO_AUTOFILL = 'BATCH_NO_AUTOFILL';
export const BATCH_NO_DATE = 'BATCH_NO_DATE';
export const BATCH_NO_EXP_DATE = 'BATCH_NO_EXP_DATE';
export const INFO_HIDDEN = 'INFO_HIDDEN';
